import { render, staticRenderFns } from "./FeatureDisplay.vue?vue&type=template&id=167c8ee5"
import script from "./FeatureDisplay.vue?vue&type=script&lang=js"
export * from "./FeatureDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports